import React from "react"
import { useState, useEffect } from "react"
import { validSesion } from "./datainfo/dto"
import {Menu,Dash} from "./menu"
import { Mensaje } from "./Message/message"
const Inicio = () => {
    
    /*if(!validSesion()){
       // console.log("validSesion: "+validSesion());
        window.location.assign('/login');
        return;
    }*/
    useEffect(()=>{
        if(!validSesion()){
            window.location.assign('/login');
            return;
        }
    },[]);
     
    return(
        <>
            <div className="main">
                <Menu />
                <Dash>
                    <p className="h4">BIENVENIDOS</p>
                </Dash>
            </div>  
        </>
    )
}

export default Inicio;